import { Expired as PoaExpired } from './expired';

export default PoaExpired;
